'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIFlex from 'UIComponents/layout/UIFlex';
import EditorWrapper from 'DesignEditorsUI/components/shared/EditorWrapper';
import Toolbar from 'DesignEditorsUI/components/shared/Toolbar';
import Navigation from './nav/Navigation';
export default class Settings extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      toolbarProps: {}
    };

    this.registerToolbarContent = (toolbarProps = {}) => {
      this.setState({
        toolbarProps
      });
    };
  }

  /*
   * Render
   */
  renderToolbar() {
    const _this$state$toolbarPr = this.state.toolbarProps,
          {
      className
    } = _this$state$toolbarPr,
          props = _objectWithoutPropertiesLoose(_this$state$toolbarPr, ["className"]);

    const cx = classNames('settings-toolbar', className);
    let leftContent = [/*#__PURE__*/_jsx(Navigation, {}, "nav")];

    if (props.leftContent) {
      leftContent = leftContent.concat(Children.toArray(props.leftContent));
    }

    return /*#__PURE__*/_jsx(Toolbar, Object.assign({
      className: cx
    }, props, {
      leftContent: leftContent
    }));
  }

  render() {
    const {
      registerToolbarContent
    } = this;
    return /*#__PURE__*/_jsxs(EditorWrapper, {
      className: "settings-editor-app",
      children: [this.renderToolbar(), /*#__PURE__*/_jsx(UIFlex, {
        align: "stretch",
        justify: "start",
        direction: "row",
        wrap: "nowrap",
        className: "settings-content",
        children: /*#__PURE__*/_jsx("div", {
          className: "settings-column settings-editor-column",
          children: /*#__PURE__*/cloneElement(this.props.settingsEditor, Object.assign({}, this.props, {
            registerToolbarContent
          }))
        })
      })]
    });
  }

}
Settings.propTypes = {
  activeEditor: PropTypes.object.isRequired,
  settingsEditor: PropTypes.node
};